import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('LoyaltyOfferFilterContainer')(({ theme }) =>
  css({
    display: 'flex',
    paddingY: ['0', '0', 'm'],
    paddingX: ['0', '0', '24px'],
    bg: ['unset', 'unset', 'grey.4'],
    border: ['unset', 'unset', `1px solid ${theme.colors.grey[2]}`],
    borderRadius: ['unset', 'unset', '3px'],
    justifyContent: 'space-between',
    height: ['44px', '44px', 'auto'],
    marginY: ['xs', 'xs', '0'],
  }),
);

themeStyles.addBaseStyles('FilterWrapper')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'xs',
    minWidth: ['unset', 'unset', '250px'],
  }),
);

themeStyles.addBaseStyles('RegionAndSortContainer')(({ isLoyaltyFilterVisible }) =>
  css({
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    gap: ['l', 'l', 'xl'],
    width: '100%',
    justifyContent: isLoyaltyFilterVisible ? 'flex-end' : 'space-between',
  }),
);

themeStyles.addBaseStyles('CheckboxContainer')(({ theme }) =>
  css({
    display: 'flex',
    alignItems: 'center',
    borderBottom: [`1px solid ${theme.colors.grey[2]}`, `1px solid ${theme.colors.grey[2]}`, 'unset'],
    paddingBottom: ['m', 'm', 'unset'],
  }),
);

themeStyles.addBaseStyles('CheckboxLabel')(
  css({
    display: 'flex',
    gap: 'xs',
    alignItems: 'center',
  }),
);

themeStyles.addBaseStyles('OfferRegionWrapper')(({ theme }) =>
  css({
    display: 'flex',
    gap: ['xs'],
    flexDirection: 'column',
    borderBottom: [`1px solid ${theme.colors.grey[2]}`, `1px solid ${theme.colors.grey[2]}`, 'unset'],
    paddingBottom: ['m', 'm', 'unset'],
  }),
);

themeStyles.addBaseStyles('SortByWrapper')(({ theme }) =>
  css({
    display: 'flex',
    gap: 'xs',
    flexDirection: 'column',
    minWidth: ['unset', 'unset', '200px'],
    borderBottom: [`1px solid ${theme.colors.grey[2]}`, `1px solid ${theme.colors.grey[2]}`, 'unset'],
    paddingBottom: ['m', 'm', 'unset'],
  }),
);

themeStyles.addBaseStyles('IconButton')(
  css({
    margin: 'auto 0',
    outline: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    width: 'fitContent',
    height: 'fitContent',
    cursor: 'pointer',
  }),
);

themeStyles.addBaseStyles('MobileFilterContainer')(
  css({
    display: 'flex',
    gap: 'l',
    flexDirection: 'column',
    paddingTop: 'l',
  }),
);

themeStyles.addBaseStyles('StyledButton')(
  css({
    minWidth: 'unset',
    width: '100%',
    borderRadius: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'm',
  }),
);

themeStyles.addBaseStyles('BtnWrapper')(
  css({
    display: 'flex',
    marginLeft: '-20px',
    marginRight: '-20px',
    position: 'fixed',
    bottom: '0',
    width: '100%',
  }),
);

themeStyles.addBaseStyles('ModalHeader')(
  css({
    position: 'fixed',
    top: 'xs',
    zIndex: 'modal',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pr: ['28px', '28px', 0],
  }),
);

themeStyles.addBaseStyles('StyledTooltip')(
  css({
    ml: '4px',
    position: 'absolute',
    top: '-5px',
  }),
);

themeStyles.addBaseStyles('ChangeLocationButton')(() =>
  css({
    textDecoration: 'none',
    '&:hover': {
      '& svg path': {
        fill: 'white',
      },
    },
  }),
);

themeStyles.addBaseStyles('ButtonWrapper')(() =>
  css({
    display: 'flex',
    alignItems: 'center',
  }),
);

export default themeStyles;
